import React, { useEffect, useState } from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import GoogleLoginStep from '../Pages/GoogleLoginStep';
import RegisterDetailsStep from '../Pages/RegisterDetailsStep';
import { auth, db } from '../firebase/firebase';
import { useAuthState } from 'react-firebase-hooks/auth'
import { doc, setDoc } from 'firebase/firestore';

export default function RegisterPopup({ open, initStep = 1 }) {
    const [user, isLoading] = useAuthState(auth);
    const [step, setStep] = useState(initStep);
    const [formData, setFormData] = useState({
        id: "",
        title: "",
        image: "/images/default-profile.png.png",
        gender: "",
        phoneNumber: "",
        coverImage: "/images/maya-cover1.jpg",
        birthDate: null,
        location: "",
        interests: "",
        favorite_trip_locations: [],
        favorite_trip_styles: [],
        about: "",
        looking_for: "",
        favoriteTrips: [],
        isRegistered: true
    });

    useEffect(() => {
        if (!isLoading && user) {
            setFormData({ ...formData, id: user.uid, title: "", image: "/images/default-profile.png.png", phoneNumber: user.phoneNumber })
        }
    }, [isLoading, user])

    const handleClose = () => {
        setFormData({});
        setStep(1);
    };

    const handleFinish = async () => {
        console.log('Final Form Data:', formData);
        await setDoc(doc(db, 'users', formData.id), { ...formData, birthDate: formData.birthDate });
    };

    return (
        (!isLoading && <Modal open={open} onClose={handleClose}>
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                bgcolor: 'background.paper',
                borderRadius: 2,
                boxShadow: 24,
                p: 4,
                width: '95%',
                maxWidth: 750,
                maxHeight: '90vh',
                overflowY: 'auto',
            }}>
                {step === 1 ? (
                    <GoogleLoginStep
                        formData={formData}
                        setFormData={setFormData}
                        onNext={() => setStep(2)}
                    />
                ) : (
                    <RegisterDetailsStep
                        formData={formData}
                        setFormData={setFormData}
                        onFinish={handleFinish}
                    />
                )}
            </Box>
        </Modal>)
    );
}
